var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLaunch10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1095_2771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.775 48.2103H22.569C23.5744 48.2103 24.5022 47.6743 25.0038 46.8045L43.3063 15.1012C43.8079 14.2315 43.8079 13.1594 43.3063 12.2897L39.9093 6.40628C38.8265 4.53124 36.1205 4.53124 35.0377 6.40628L13.3381 43.9931C12.2553 45.8681 13.6093 48.2103 15.7728 48.2103H15.775Z",
    fill: "url(#paint0_linear_1095_2771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6987 59.7103L32.0957 65.5937C33.1785 67.4688 35.8845 67.4688 36.9673 65.5937L47.0034 48.2104C47.505 47.3407 48.435 46.8046 49.4381 46.8046H56.2257C58.3914 46.8046 59.7433 44.4603 58.6605 42.5874L50.2476 28.0155C49.1647 26.1405 46.4587 26.1405 45.3759 28.0155L34.524 46.8068L28.6965 56.9031C28.1949 57.7728 28.1949 58.8449 28.6965 59.7146L28.6987 59.7103Z",
    fill: "url(#paint1_linear_1095_2771)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1095_2771",
    x1: 28.3198,
    y1: 5,
    x2: 28.3198,
    y2: 48.2103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EABF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1095_2771",
    x1: 43.6811,
    y1: 26.6093,
    x2: 43.6811,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EABF8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1095_2771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLaunch10);
export default __webpack_public_path__ + "static/media/Logo_Launch10.224424c89f9279da026d515db3ee6f1e.svg";
export { ForwardRef as ReactComponent };